import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Nav";
import { SITE, SERVICE_LINKS, COUNTRY_LINKS } from "@/lib/content";

const col = (title, links) => ({ title, links });

const COLS = [
  col("Services", [
    ...SERVICE_LINKS.map((s) => ({ label: s.title, to: `/services/${s.slug}` })),
    { label: "Pricing", to: "/pricing" },
  ]),
  col("Sourcing", [
    ...COUNTRY_LINKS.map((c) => ({ label: c.name, to: `/sourcing/${c.slug}` })),
    { label: "All sourcing", to: "/sourcing" },
  ]),
  col("Company", [
    { label: "About", to: "/about" },
    { label: "Vision", to: "/vision" },
    { label: "Case studies", to: "/case-studies" },
    { label: "Insights", to: "/insights" },
    { label: "FAQ", to: "/faq" },
  ]),
  col("Tools", [
    { label: "Margin calculator", to: "/tools/landed-cost-and-margin-calculator" },
    { label: "Free downloads", to: "/tools/downloads" },
    { label: "First run guide", to: "/guides/first-production-run-australia" },
    { label: "Book a fit call", to: "/book" },
    { label: "Contact", to: "/contact" },
  ]),
];

export default function Footer() {
  return (
    <footer className="on-dark" style={{ backgroundColor: "var(--charcoal-deep)", color: "var(--bone)" }} data-testid="site-footer">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-white/10 pb-16">
          <div className="md:col-span-4">
            <div className="text-4xl"><Wordmark dark /></div>
            <p className="mt-6 max-w-xs text-[var(--muted-dark)] leading-relaxed t-sm">
              A commercial advisory for fashion and consumer product brands. Cost, price, sourcing, range and cash.
            </p>
            <div className="mt-7 space-y-1.5 t-sm">
              <a href={`mailto:${SITE.email}`} className="lnk lnk-bone block">{SITE.email}</a>
              <p className="text-[var(--muted-dark)]">{SITE.location}</p>
              <a href={SITE.linkedin} target="_blank" rel="noreferrer" className="lnk lnk-bone block">LinkedIn</a>
            </div>
            <button
              onClick={() => window.dispatchEvent(new Event("prox:newsletter"))}
              className="btn btn-outline-bone mt-6 text-[13px]"
              style={{ padding: "10px 20px" }}
              data-testid="footer-subscribe"
            >
              Get the field notes
            </button>
          </div>
          {COLS.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <p className="eyebrow">{c.title}</p>
              <ul className="mt-5 space-y-2.5 t-sm">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-[var(--stone)] hover:text-[var(--bone)] transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col md:flex-row justify-between gap-4 font-mono text-[11.5px] uppercase tracking-wide text-[var(--muted-dark)]">
          <span>© {new Date().getFullYear()} Prox. Prices in AUD, inclusive of GST.</span>
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy-policy" className="hover:text-[var(--bone)] transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-[var(--bone)] transition-colors">Terms</Link>
            <Link to="/sitemap" className="hover:text-[var(--bone)] transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
